import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LoginContabil, ReservaDotacaoItem } from 'eddydata-lib';

declare var $: any;

@Component({
  selector: 'lib-compra-ficha-reserva-dotacao',
  templateUrl: './compra-ficha-reserva-dotacao-dlg.component.html'
})
export class CompraFichaReservaDotacaoDlg implements OnInit {

  @Input() public login: LoginContabil;
  @Input() visualizar: boolean = false;
  @Input() static : boolean = false;
  @Input() reservaDotacaoItens: ReservaDotacaoItem[];
  @Output() callBackVisualizar: EventEmitter<ReservaDotacaoItem> = new EventEmitter();

  ngOnInit(): void { }

  public onHide() {
    this.hide();
  }

  public show() {
    this.visualizar = true;
  }

  public hide() {
    this.visualizar = false;
    $('#dlgFichaReservaDotacao').modal('hide');
  }

  public selecionarEvent(reserva: ReservaDotacaoItem) {
    this.callBackVisualizar.emit(reserva);
    this.hide();
  }
}
